import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import AvailabilitySlots from './availability-slots';
import { withEnabledFeatures } from '../../utils/features';
import { SimpleLoadingComponent } from '../../utils/apollo';

export const query = gql`
  query AvailabilitySlots($fromDate: OrdinalDate!, $toDate: OrdinalDate!) {
    viewer {
      id
      repVisitsSchedule(fromDate: $fromDate, toDate: $toDate) {
        id
        appointments {
          id
          appointmentId
          startISOTime
          endISOTime
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: {
    fetchPolicy: 'cache-and-network',
  },
});

export default withEnabledFeatures(SimpleLoadingComponent(graphqlData)(AvailabilitySlots));
